<template>
  <div
    class="flex flex-col-reverse items-center gap-24 md:flex-row md:justify-between"
  >
    <div class="w-full space-y-16 md:max-w-[600px]">
      <h1 class="punchline">
        {{ i18n(translations.title) }}
      </h1>

      <p class="body-1 text-static-default-low">
        {{ i18n(translations.subtitle) }}
      </p>

      <div class="flex gap-8">
        <RevButton
          class="rounded-round shadow-short"
          size="small"
          variant="brand"
          @click="emit('explore-plans-click')"
        >
          <span class="flex items-center justify-center gap-4">
            {{ i18n(translations.ctaExplorePlans) }}
            <IconArrowDownRight size="16" />
          </span>
        </RevButton>
      </div>
    </div>

    <RevIllustration
      :alt="i18n(translations.imageAlt)"
      class="w-full md:max-w-[500px]"
      :height="728"
      image-class-names="w-full h-auto"
      loading="eager"
      src="/img/telco-partnership/us-telco-hero-banner.png"
      :width="854"
    />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevIllustration } from '@ds/components/Illustration'
import { IconArrowDownRight } from '@ds/icons/IconArrowDownRight'

import translations from './HeroSection.translations'

const emit = defineEmits<{
  'explore-plans-click': []
}>()

const i18n = useI18n()
</script>
